import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message } from 'antd';
import Filter from './components/Filter';
import List from './components/List';
import OnMarket from './components/OnMarket';
import Milestone from './components/Milestone';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/noticeActions';
import './style.less'
import ExportModal from './components/ExportModal';

class ImportantMilestone extends Component {

    constructor(props) {
        super(props);
        const { params } = props;
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
            },
            searchParams: {
                type:'marketRegiste',
                ...params
            },
            data: [],
            business: [],
            area: [],
            loading: false,
            type: undefined,
            record: {},
            approvalTypeList:[]
        };
    }

    componentDidMount() {
        this.queryWithLevelByParams();
        this.queryApprovalTypeList();
        this.queryArea();
        this.loadData();
    }

    componentWillUnmount() {
        this.props.saveParams({ investigationName: undefined });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, {
                typeName: 'LINE_OF_BUSINESS'
            }).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            this.setState({ business: res.typeConfigureList || [] });
        });
    }

    queryApprovalTypeList = () =>{
        dictCache.getDict('MEDICINE_APPROVAL_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.nationalverification.queryConfigureListByType,
                data: {
                    type:'MEDICINE_APPROVAL_TYPE'
                },
                dataType: 'json',
                doneResult: res => cb(res),
                errorResult: err => {
                    console.log(err);
                }
            });
        }, res => {
            const  { datas } = res;
            this.setState({approvalTypeList:datas})
        });
    }

    queryArea = () => {
        dictCache.getDict('AREA_ALL', cb => {
            Fetch.post(API_URL.common.queryAllInvestigationArea)
            .then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            this.setState({ area: res.data });
        });
    }

    loadData = () => {
        const { pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        Fetch.post(API_URL.nationalverification.queryMilepostMarketRegisteList, {
            offset: current,
            limit: pageSize,
            ...searchParams,
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    handleSearch = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    handleReset = () =>{
        this.setState({ searchParams:{type:'marketRegiste'} }, () => {
            this.loadData();
        });
    }

    handleExport = () => {
        const { pagination, searchParams } = this.state;
        this.ExportModalRef.show(searchParams, pagination);
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    update = (type, record) => {
        this.setState({
            type,
            record,
        }, () => {
            !type && this.loadData();
        });
    }

    remove = (nationVerifyId) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.nationalverification.delNationVerify, {
            nationVerifyId,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({ loading: false }, () => {
                this.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    download = (nationVerifyId) => {
        ExportUtil.export({ nationVerifyId }, null, API_URL.qualityManagement.exportComplaintRecordWord);
    }

    showMilestone = (record) => {
        this.MilestoneRef.show(record);
    }
    
    showOnMarket = (record) => {
        this.onMarketRef.show(record);
    }

    render() {
        const { business, area, searchParams, data, loading, pagination ,approvalTypeList} = this.state;
        return (
            <div className="content">
                <SideNav selectKey="ImportantMilestone" />
                    <div className="main">
                        <Filter
                            area={area}
                            business={business}
                            searchParams={searchParams}
                            onSearch={this.handleSearch}
                            onExport={this.handleExport}
                            onChange={this.handleFilterChange}
                            onReset={this.handleReset}
                        />
                        <List
                            data={data}
                            loading={loading}
                            pagination={pagination}
                            remove={this.remove}
                            download={this.download}
                            onChange={this.handleTableChange}
                            showMilestone={this.showMilestone}
                            showOnMarket={this.showOnMarket}
                            approvalTypeList={approvalTypeList}
                        />
                    </div>
                <Milestone ref={el => this.MilestoneRef = el} loadData={this.loadData}/>
                <OnMarket ref={el => this.onMarketRef = el} loadData={this.loadData} approvalTypeList={approvalTypeList}/>
                <ExportModal ref={el => this.ExportModalRef = el}/>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportantMilestone);


// WEBPACK FOOTER //
// ./src/components/qualityManagement/ImportantMilestone/index.js